// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/web-" + {"179":"components","407":"panel","521":"navigation","666":"styleguide","809":"users","818":"default","945":"dashboard"}[chunkId] + ".js";
};